module.exports = __webpack_public_path__ + "static/media/Nov_2025_2.ac6b01a2.webp";